import { combineReducers } from "redux";
import withdrawl_request from "../features/admin/withdrawl_request/Slice";

const withdrawlRequest = combineReducers({
  withdrawl_request: withdrawl_request,
});

export default withdrawlRequest;
